package kz.dentalcrm.app.screens.protocols.add

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_treatment_added
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.TreatmentRepository
import kz.dentalcrm.app.screens.protocols.add.mvi.AddProtocolViewState
import kz.dentalcrm.app.screens.protocols.add.mvi.AddProtocolViewEvent
import kz.dentalcrm.app.screens.protocols.add.mvi.AddProtocolViewSideEffect
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class AddProtocolViewModel :
    BaseStateViewModel<AddProtocolViewEvent, AddProtocolViewState, AddProtocolViewSideEffect>() {

    private val treatmentRepository: TreatmentRepository by inject()

    private val _isLoading = MutableStateFlow(false)
    val loading: StateFlow<Boolean> = _isLoading

    private fun addTreatment(name: String, code: String) {
        setState {
            copy(
                screenState = AddProtocolViewState.ScreenState.Adding
            )
        }
        launch(Dispatchers.Default) {
            when (val result = treatmentRepository.addEditTreatment(
                name = name,
                code = code,
                id = null
            )) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_treatment_added), SnackbarEvent.SnackbarType.Green))
                    setState {
                        copy(
                            screenState = AddProtocolViewState.ScreenState.Added
                        )
                    }
                }

                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddProtocolViewState.ScreenState.Error(
                                error = result.message
                                    ?: "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }

                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddProtocolViewState.ScreenState.Error(
                                error = "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }
            }
        }
    }

    override fun setInitialState() = AddProtocolViewState()

    override fun handleEvents(event: AddProtocolViewEvent) {
        when (event) {
            is AddProtocolViewEvent.AddProtocol -> {
                addTreatment(
                    name = event.naming,
                    code = event.code
                )
            }
            AddProtocolViewEvent.Reset -> setState { copy(screenState = AddProtocolViewState.ScreenState.Idle) }
        }
    }

    override fun onCleared() {
        setState { AddProtocolViewState() }
        _isLoading.value = false
    }
}